import { z } from 'zod'
import { IntegrationRequestType, IntegrationType } from '../enums.js'

const integrationRequestSchema = z.object({
  method: z.string(),
  baseUrl: z.string(),
  path: z.string(),
  normalizedPath: z.string(),
  headers: z.record(z.string(), z.unknown()).optional(),
  params: z.record(z.string(), z.unknown()).optional(),
  data: z.unknown().optional(),
})

export type IntegrationRequest = z.infer<typeof integrationRequestSchema>

const integrationResponseSchema = z.object({
  status: z.number(),
  statusText: z.string(),
  headers: z.record(z.string(), z.unknown()).optional(),
  data: z.unknown().optional(),
})

export type IntegrationResponse = z.infer<typeof integrationResponseSchema>

// In the future this can represent db queries or other protocols. For now it's just HTTP requests to Agave.
const integrationRequestDocumentSchema = z.object({
  type: z.enum(IntegrationRequestType),
  companyIntegrationId: z.string().nullable(),
  integrationType: z.enum(IntegrationType).nullable(),
  request: integrationRequestSchema,
  response: integrationResponseSchema.nullable(),
  startedAt: z.date(),
  endedAt: z.date(),
})

export type IntegrationRequestDocument = z.infer<typeof integrationRequestDocumentSchema>
